<div id="loginActivation" class="forget-password-container ya-typography">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true" [disableNavigateBack]="true"
    (onNavigateBackClick)="navigateBack()">
    <h2 class="ya-header-title" langkey="phForgetPassword_Title"></h2>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <div class="content-message">
      <span langkey="phForgetPassword_Message"></span>
    </div>
    <form #forgetPasswordForm="ngForm" class="form-wrapper" novalidate>
      <ya-customInput name="customerUserName" inputType="text" [inputTrim]="true" [(ngModel)]="userName"
        (enterKeyUp)="handleEnterKeyup($event)" inputPlaceholder="phForgetPassword_Email_PlaceHolder" appEmailValidator
        required>
        <ng-container *ngIf="forgetPasswordForm.form.controls['customerUserName']">
          <ya-errorvalidation
            [controlValidation]="forgetPasswordForm.form.controls['customerUserName'].invalid && forgetPasswordForm.form.controls['customerUserName'].touched"
            errorMessage="phForgetPassword_ValidationMessage"></ya-errorvalidation>
        </ng-container>
      </ya-customInput>
      <div class="ya-webshop-button-container">
        <ng-container *ngIf="forgetPasswordForm.valid; then activeButton else deactiveButton"></ng-container>
        <ng-template #activeButton>
          <button id="submitForm" mat-flat-button (click)="resetPassword(forgetPasswordForm)">
            <span langkey="phForgetPassword_ResetPassword"></span>
          </button>
        </ng-template>
        <ng-template #deactiveButton>
          <span (click)="showValidationMessage(forgetPasswordForm)">
            <button mat-flat-button disabled>
              <span langkey="phForgetPassword_ResetPassword"></span>
            </button>
          </span>
        </ng-template>
      </div>
    </form>
  </div>
</div>